module.exports = "https://assets.rebelbooks.com/images/added_into_library.svg?c8be74485a32c550a1a5d1f19dd83e5b";